import axios from 'axios';
import { AUTH_LOCALSTORAGE, BASE_URL, NAVIGATION_LOGS } from './constants';

const APPLICATION_JSON_TYPE = 'application/json';
const timeout = 60000;

export const api = axios.create({
  baseURL: BASE_URL,
  timeout,
  headers: {
    accept: APPLICATION_JSON_TYPE,
    'Content-Type': APPLICATION_JSON_TYPE,
  },
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers['x-session-id'] =
    sessionStorage.getItem('session_id') || '';

  config.headers['x-client-time'] = new Date().toISOString();

  return config;
});
api.interceptors.response.use(
  (response) => {
    if (response.config.url?.includes(NAVIGATION_LOGS)) {
      return response;
    }

    // Fire-and-forget: o log de navegação nunca deve atrasar a resposta.
    void api.post(NAVIGATION_LOGS, {
      type: 'API',
      action: response.config.method?.toUpperCase(),
      endpoint: response.config.url,
      statusCode: response.status,
      timestamp: new Date().toISOString(),
    }).catch(() => {});

    return response;
  },
  (error) => {
    if (error.config?.url?.includes(NAVIGATION_LOGS)) {
      return Promise.reject(error);
    }

    // Fire-and-forget: o log de erro nunca deve atrasar a rejeição.
    void api.post(NAVIGATION_LOGS, {
      type: 'ERROR',
      action: error.config?.method?.toUpperCase(),
      endpoint: error.config?.url,
      statusCode: error.response?.status,
      error: error.message,
      timestamp: new Date().toISOString(),
    }).catch(() => {});

    return Promise.reject(error);
  }
);